import { LitElement, html, css, styles, repeat, utils } from '@hh/global.js'
const { visuallyHidden } = styles
const { generateDividerMarkup } = utils

class WearItWithNosto extends LitElement {
  static properties = {
    loading: {
      reflect: true,
    },
    title: {
      type: String,
    },
    products: {
      converter(value) {
        return JSON.parse(decodeURIComponent(value))
      },
    },
    resultId: {
      attribute: 'result-id',
      type: String,
    },
  }

  constructor() {
    super()

    // Set default states
    this.title = ''
    this.products = []

    this._generateList = this._generateList.bind(this)
    this._generateProductCard = this._generateProductCard.bind(this)
  }

  connectedCallback() {
    super.connectedCallback()
  }

  _generateList() {
    return html`
      <ul class="mini-product-cards">
        ${repeat(
      this.products,
      (product) => product.id,
      (product, index) => this._generateProductCard(product, index)
    )}
      </ul>
    `
  }

  _generateProductCard(item) {
    return html`
      <li class="accordion-card-item">
        <mini-product-card
          class="product-card"
          role="group"
          aria-label="${window.variantStrings.product}"
          hydrate
          product-id="${item.product_id}"
          product-handle="${item.url.split('/').slice(-1)}"
          url-postfix=""
          data-product-href="${item.url}"
          data-product-image-primary="${item.image_url}"
          data-product-image-secondary="${item.alternate_image_urls[0] || ''}"
          data-product-title="${item.name}"
          data-product-description=""
          data-product-price="${item.price}"
          data-section-headline="${this.sectionHeadline}"
          variantType="color"
        ></mini-product-card>
      </li>
    `
  }

  createRenderRoot() {
    return this
  }

  render() {
    return html`
      <hh-accordion>
        <div class="product-accordion wear-it-with__accordion">
          <h3 class="color-black no-margin wear-it-with__title">
            <button class='h4 bold js-accordion-toggle accordion-toggle product-accordion__toggle flex jcb aic' aria-expanded='true' aria-controls='accordion-wear-it-with'>
              ${this.title}
              <div class="toggle">
                <svg
                  width="42"
                  height="42"
                  viewBox="0 0 42 42"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15 19.8809L15 20.9998L15 22.1188L27 22.0549L27 19.9449L15 19.8809Z"
                    fill="currentColor"
                  />
                  <path
                    d="M22.1189 15L20.9999 15L19.8809 15L19.9448 27L22.0548 27L22.1189 15Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
            </button>
          </h3>
          <div id='accordion-wear-it-with' class='js-accordion-content accordion-content product-accordion__content body color-dark-grey text-b2'>
            <div class="nosto-wear-it-with-container">
              <div class="nosto-wear-it-with-section">
                ${this._generateList()}
              </div>
            </div>
          </div>
        </div>
      </hh-accordion>
    `
  }

  static styles = [visuallyHidden, css``]
}

customElements.define('wear-it-with', WearItWithNosto)
